import React, {useRef} from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"
import ProjectIcon from "../../../../../../gd-components/icons/project/project-icon-ui5"
import HintPopover from "../../../../../../gd-ui/hint-popover/hint-popover"

// const debug = "FieldProject_ViewGroup"
const debug = false

export default function FieldProject_ViewGroup(props: FieldViewGroupProps) {

    const value     = props.field.getViewValue(props.model)
    const label     = props.field.groupLabel(value, props.groupBy) || 'No parent'

    const labelRef  = useRef<HTMLDivElement>(null)

    const classes   = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    const checkShowHint = () => {
        return !!labelRef.current
            && labelRef.current.scrollWidth > labelRef.current.clientWidth
    }

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <ProjectIcon projectId={value}/>
                </div>
            }

            <div ref        = {labelRef}
                 className  = "max-w-100-percent txt-truncate view-group-label">
                {label}
            </div>
            <HintPopover
                hint            = {label}
                multiline       = {true}
                checkShowHint   = {checkShowHint}
            />
        </div>
    )
}
